import React, {useState, useEffect, useRef} from "react";
import {AutoComplete} from "primereact/autocomplete";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import {base, project_events_url, projects_url, locations_url} from "../../../api";
import {Toast} from "primereact/toast";
import {Link, useNavigate} from "react-router-dom";

export default function BeneficareAddForm() {
	const toast = useRef(null);
	const navigate = useNavigate();
	const [sendData, setSendData] = useState({date: "", name: ""});
	const [inputList, setInputList] = useState([
		{
			full_name: "",
			address: "",
			company: "",
			position: "",
			phone: "",
			email: "",
			gender: "",
			age: "",
		},
	]);
	const [project, setProject] = useState([]);
	const [selectedProject, setSelectedProject] = useState(null);
	const [filteredProject, setFilteredProject] = useState([]);
	const [location, setLocation] = useState([]);
	const [selectedLocation, setSelectedLocation] = useState(null);
	const [filteredLocation, setFilteredLocation] = useState([]);

	useEffect(() => {
		axios.all([axios.get(base + projects_url), axios.get(base + locations_url)]).then(
			axios.spread((projRes, locRes) => {
				setProject(projRes.data);
				setLocation(locRes.data);
			}),
		);
	}, []);

	function submitData() {
		axios
			.post(base + project_events_url, {
				project_id: selectedProject?.id,
				name: sendData.name,
				date: sendData.date,
				location_id: selectedLocation?.id,
				beneficiaries: inputList,
			})
			.then(() => {
				toast.current.show({
					severity: "success",
					summary: "Success",
					detail: "Added successfully",
					life: 3000,
				});
				setTimeout(() => navigate("/beneficiaries"), 1500);
			})
			.catch(() => {
				toast.current.show({
					severity: "error",
					summary: "Error",
					detail: "Please fill all fields",
					life: 3000,
				});
			});
	}

	const searchProject = e => {
		const q = e.query.toLowerCase();
		setFilteredProject(project.filter(item => item.full_name_am?.toLowerCase().includes(q)));
	};

	const searchLocation = e => {
		const q = e.query.toLowerCase();
		setFilteredLocation(location.filter(item => item.title_am?.toLowerCase().includes(q)));
	};

	const handleInputChange = (e, index) => {
		let {name, value} = e.target;
		// if it's one of the gender radios, normalize to the "gender" field
		if (name.startsWith("gender-")) {
			name = "gender";
		}
		const list = [...inputList];
		list[index][name] = value;
		setInputList(list);
	};

	const handleRemoveClick = index => {
		const list = [...inputList];
		list.splice(index, 1);
		setInputList(list);
	};

	const handleAddClick = () => {
		setInputList([
			...inputList,
			{
				full_name: "",
				address: "",
				company: "",
				position: "",
				phone: "",
				email: "",
				gender: "",
				age: "",
			},
		]);
	};

	const AGE_RANGES = [
		{label: "16-18", value: "16-18"},
		{label: "18-25", value: "18-25"},
		{label: "25-30", value: "25-30"},
		{label: "30+", value: "30+"},
	];

	return (
		<>
			<div className="col-lg-12 mb-4">
				<div className="card b-radius b-shadow px-4 py-4 mb-3">
					<div className="fs-5 fw-bold text-uppercase border-bottom mb-3 pb-3">
						Ավելացնել նոր միջոցառում
					</div>
					<div className="row gx-3 gy-3">
						<div className="col-3">
							<label className="mb-2">Ծրագիր</label>
							<AutoComplete
								dropdown
								className="w-100"
								placeholder="Ընտրել ցանկից"
								field="full_name_am"
								completeMethod={searchProject}
								suggestions={filteredProject}
								value={selectedProject}
								onChange={e => setSelectedProject(e.value)}
								itemTemplate={item => (
									<div className="d-flex flex-column">
										<span className="text-primary">{item.full_name_am?.slice(0, 30)}</span>
										<span className="text-secondary small">
											{item.full_name_en?.slice(0, 30) || "not provided"}
										</span>
									</div>
								)}
							/>
						</div>
						<div className="col-3">
							<label className="mb-2">Միջոցառման անվանում</label>
							<InputText
								type="text"
								className="w-100 p-2"
								value={sendData.name}
								onChange={e => setSendData({...sendData, name: e.target.value})}
							/>
						</div>
						<div className="col-3">
							<label className="mb-2">Միջոցառման օրը</label>
							<InputText
								type="date"
								className="w-100 p-2"
								value={sendData.date}
								onChange={e => setSendData({...sendData, date: e.target.value})}
							/>
						</div>
						<div className="col-3">
							<label className="mb-2">Վայրը</label>
							<AutoComplete
								dropdown
								className="w-100"
								placeholder="Ընտրել ցանկից"
								field="title_am"
								completeMethod={searchLocation}
								suggestions={filteredLocation}
								value={selectedLocation}
								onChange={e => setSelectedLocation(e.value)}
								itemTemplate={item => (
									<div className="d-flex flex-column">
										<span className="text-primary">{item.title_am?.slice(0, 30)}</span>
										<span className="text-secondary small">
											{item.title_en?.slice(0, 30) || "not provided"}
										</span>
									</div>
								)}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="col-12">
				{inputList.map((item, index) => (
					<div key={index} className="card b-radius b-shadow mb-4 p-3">
						<div className="row gx-2 gy-2">
							<div className="col-md-3">
								<InputText
									name="full_name"
									className="w-100"
									placeholder="Շահառուի անուն"
									value={item.full_name}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3">
								<InputText
									name="address"
									className="w-100"
									placeholder="Հասցե"
									value={item.address}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3">
								<InputText
									name="company"
									className="w-100"
									placeholder="Աշխատավայր"
									value={item.company}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3">
								<InputText
									name="position"
									className="w-100"
									placeholder="Պաշտոն"
									value={item.position}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3">
								<InputText
									name="phone"
									className="w-100"
									placeholder="Հեռախոս"
									value={item.phone}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3">
								<InputText
									name="email"
									className="w-100"
									placeholder="Էլ. հասցե"
									value={item.email}
									onChange={e => handleInputChange(e, index)}
								/>
							</div>
							<div className="col-md-3 d-flex align-items-center">
								<div className="form-check me-3">
									<input
										className="form-check-input"
										type="radio"
										name={`gender-${index}`}
										value="Male"
										checked={item.gender === "Male"}
										onChange={e => handleInputChange(e, index)}
									/>
									<label className="form-check-label">Արական</label>
								</div>
								<div className="form-check">
									<input
										className="form-check-input"
										type="radio"
										name={`gender-${index}`}
										value="Female"
										checked={item.gender === "Female"}
										onChange={e => handleInputChange(e, index)}
									/>
									<label className="form-check-label">Իգական</label>
								</div>
							</div>

							<div className="col-md-2">
								<select
									className="form-select"
									name="age"
									value={item.age}
									onChange={e => handleInputChange(e, index)}>
									<option value="">Ընտրեք տարիքը</option>
									{AGE_RANGES.map(range => (
										<option key={range.value} value={range.value}>
											{range.label}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className="d-flex justify-content-end mt-2">
							{inputList.length > 1 && (
								<Button
									severity="danger"
									text
									rounded
									icon="pi pi-trash"
									onClick={() => handleRemoveClick(index)}
									className="me-2"
								/>
							)}
							{index === inputList.length - 1 && (
								<Button
									severity="success"
									text
									rounded
									icon="pi pi-plus"
									onClick={handleAddClick}
								/>
							)}
						</div>
					</div>
				))}
			</div>

			<div className="col-12 text-center mb-4">
				<Link to="/beneficiaries" className="btn btn-secondary me-3 px-5">
					Cancel
				</Link>
				<Button label="Save" rounded severity="primary" onClick={submitData} />
			</div>

			<Toast ref={toast} />
		</>
	);
}
